import {Breadcrumbs, Btn, H5} from "../../AbstractElements";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import React, {useState} from "react";
import {UserForms} from "./UserForms";
import Drawer from 'react-modern-drawer';
import {UserDataTable} from "../../Components/DataTables/UserDataTable";
import {UserLookupForms} from "./UserLookupForms";

const ManageUserPage = () => {
    const [drawerState, setDrawerState] = useState({
        forms: false,
        lookup: false,
        editId: 0
    })

    const [refreshState, setRefreshState] = useState({
        userDataTable: false
    })

    const closeAllDrawer = () => {
        setDrawerState({
            forms: false,
            editId: 0
        })
    }

    return (
        <>
            <Breadcrumbs parent="Manage" title="Manage User" mainTitle="Manage User"/>
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="pb-0">
                                <Row className="justify-content-between">
                                    <Col md={"auto"}>
                                        <H5>Manage Registered User</H5>
                                    </Col>
                                    <Col md={"auto"}>
                                        <Btn attrBtn={{
                                            color: "secondary",
                                            className: "m-r-15",
                                            onClick: (e) => setDrawerState({...drawerState, forms: true, editId: 0})
                                        }}>New User</Btn>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <UserDataTable drawerState={drawerState} setDrawerState={setDrawerState}
                                               refresh={refreshState.userDataTable}
                                               onRefreshFinish={() => setRefreshState({
                                                   ...refreshState,
                                                   userDataTable: false
                                               })}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Drawer
                open={drawerState.forms}
                onClose={closeAllDrawer}
                direction="right"
                className={'creation-drawer'}
            >
                <UserForms id={drawerState.editId} refreshState={refreshState} setRefreshState={setRefreshState}
                           onFinish={() => closeAllDrawer()}/>
            </Drawer>

            <Drawer
                open={drawerState.lookup}
                onClose={closeAllDrawer}
                direction="right"
                className={'creation-drawer'}
            >
                <UserLookupForms id={drawerState.editId} refreshState={refreshState} setRefreshState={setRefreshState}
                           onFinish={() => closeAllDrawer()}/>
            </Drawer>
        </>
    )

}

export default ManageUserPage